<template>
  <v-data-table
    :headers="headers"
    :items="substances"
    :items-per-page="5"
    item-key="substance.name"
    class="elevation-6 mx-3 my-2 px-2"
    :expanded.sync="expanded"
    :footer-props="{
      'items-per-page-text': `${$t('generic.LinePerPage')}`,
      'items-per-page-all-text': `${$t('generic.All')}`,
    }"
    :no-data-text="`${$t('generic.noFav')}`"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title
          >{{ $t("generic.resultOfSearch") }} :
          {{ search !== "" ? `'${search}'` : search }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <slot></slot>
      </v-toolbar>
    </template>
    <template v-slot:item="{ item, headers }">
      <tr>
        <td v-for="(headerValue, headerInd) in headers" :key="headerInd">
          <div v-if="headerValue.value == 'substance'">
            <v-card
              flat
              color="transparent"
              @click="goToSub(item.substance.id)"
            >
              <v-container>
                <v-row align="start" class="my-1">
                  <v-col>
                    <v-row>
                      <div class="text-body-1">{{ item.substance.name }}</div>
                    </v-row>
                    <v-row>
                      <div class="mr-2 text-body-2">N°CE :</div>
                      <div class="text-body-2">{{ item.substance.ce }}</div>
                    </v-row>
                    <v-row>
                      <div class="mr-2 text-body-2">N°CAS :</div>
                      <div class="text-body-2">{{ item.substance.cas }}</div>
                    </v-row>
                    <v-row>
                      <div class="mr-2 text-body-2">
                        {{ $t("searchSubstance.rulesConcern") }} :
                      </div>
                      <div class="text-body-2">{{ item.substance.count }}</div>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </div>
          <div style="display: flex; justify-content: center" v-else>
            <div v-for="(value, ind) in item" :key="ind">
              <div v-if="ind === headerValue.value">
                <div v-if="value.qte != ''">
                  <v-btn
                    @click="feed_expand(item, value, headerValue.value)"
                    icon
                    :dark="value.is_expand"
                    :class="value.is_expand ? 'btn-active-result' : ''"
                  >
                    {{ value.qte }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <ul class="pa-2">
          <li v-for="(t, a) in display.texts" :key="a">
            <a @click="goToSub(item.substance.id, t, themeSelected)">
              <!-- <v-container fluid> -->
              <v-row align="center">
                <app-flag :from="t.origin"></app-flag>
                <div class="text-body-1">{{ t.name }}</div>
              </v-row>
              <!-- </v-container> -->
            </a>
          </li>
        </ul>
        <v-divider></v-divider>
      </td>
    </template>
    <template v-slot:[`footer.page-text`]="items">
      {{ items.pageStart }} - {{ items.pageStop }} {{ $t("generic.of") }}
      {{ items.itemsLength }}
    </template>
  </v-data-table>
</template>

<style scoped>
ul {
  border-left: 2px solid #ca0538;
  padding: 16px 8px;
  margin: 8px 32px 8px 32px; /* top, right, bot, left */
  padding-left: 16px;
  list-style-type: none;
}
.btn-active-result {
  background-color: #ca0538;
  color: white;
}
</style>

<script>
import { mapMutations } from "vuex";
import AppFlag from "./AppFlag.vue";
export default {
  data() {
    return {
      expanded: [],
      display: "",
      item_selected: 1,
      themeSelected: "",
    };
  },
  props: {
    substances: Array,
    headers: Array,
    search: {
      type: String,
      default: "",
    },
  },
  components: {
    AppFlag,
  },
  methods: {
    ...mapMutations(["setLastPage", "resetCurrentPage"]),
    feed_expand(item, ind, theme) {
      // la fonction if permet de toggle l'expand
      // Si ce qui est stocké dans display est identique à
      // ce que le bouton nous renvoi alors on ecrase
      // expanded et display pour tout fermer

      // console.log("VALUE:", item);
      // console.log("IND:", ind);
      // console.log("DISPLAY:", this.display);
      // console.log("EXPANDED:", this.expanded);
      if (this.display === ind) {
        this.reset_expand();
        this.expanded = [];
        this.display = 0;
        this.themeSelected = "";
      } else {
        this.reset_expand();
        ind.is_expand = true;
        this.expanded = [item];
        this.display = ind;
        this.themeSelected = theme;
      }
    },
    reset_expand() {
      this.substances.forEach((sub) => {
        for (var params of Object.keys(sub)) {
          if (typeof sub[params] == "object") {
            sub[params].is_expand = false;
          }
        }
      });
    },
    goToSub(sub, rule, theme) {
      this.setLastPage({
        name: this.$route.name,
        params: {
          headers: this.headers,
          substances: this.substances,
          searchedValue: this.search,
        },
      });
      this.resetCurrentPage();
      this.$router.push({
        name: "ShowSubstances",
        params: { id: sub, rule: rule, theme: theme },
      });
    },
  },
};
</script>
